/**
 * Batch Processes List Handlers
 *
 * Pure command handlers for data, pagination, and loading commands.
 */

import { BatchProcessesListState } from './state';
import { BatchProcessesListCommand } from './commands';
import { CommandHandlerMap } from '@commandDrivenStateEngine/core/types';

type ExtractCommand<T extends string> = Extract<BatchProcessesListCommand, { type: T }>;

// -------- Data handlers ----------

const handleSetHistory = (
  state: BatchProcessesListState,
  cmd: ExtractCommand<'batchProcesses/list/data/setHistory'>
): BatchProcessesListState => ({
  ...state,
  historyProcesses: cmd.payload.processes,
  historyCount: cmd.payload.count,
  loading: { ...state.loading, history: false }
});

// -------- Pagination handlers ----------

const handleSetPage = (
  state: BatchProcessesListState,
  cmd: ExtractCommand<'batchProcesses/list/pagination/setPage'>
): BatchProcessesListState => ({
  ...state,
  currentPage: cmd.payload.page
});

const handleSetPerPage = (
  state: BatchProcessesListState,
  cmd: ExtractCommand<'batchProcesses/list/pagination/setPerPage'>
): BatchProcessesListState => ({
  ...state,
  perPage: cmd.payload.perPage,
  currentPage: 1
});

// -------- Loading handlers ----------

const handleSetHistoryLoading = (
  state: BatchProcessesListState,
  cmd: ExtractCommand<'batchProcesses/list/loading/setHistoryLoading'>
): BatchProcessesListState => ({
  ...state,
  loading: { ...state.loading, history: cmd.payload.isLoading }
});

// -------- Handler map ----------

export const handlers = {
  // Data
  'batchProcesses/list/data/setHistory': handleSetHistory,
  // Pagination
  'batchProcesses/list/pagination/setPage': handleSetPage,
  'batchProcesses/list/pagination/setPerPage': handleSetPerPage,
  // Loading
  'batchProcesses/list/loading/setHistoryLoading': handleSetHistoryLoading
} as CommandHandlerMap<BatchProcessesListState, BatchProcessesListCommand>;
